import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { History } from '@df/session/api/history/history';
import { HistoryOrder } from '@df/session/api/history/history-order';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { AccountBackComponent } from '../../back/account-back.component';
import { AccountViewComponent } from '../../view/account-view.component';
@Component({
    selector: 'account-order-history',
    templateUrl: './account-order-history.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [AccountBackComponent, TranslationModule]
})
export class AccountOrderHistoryComponent extends UiComponent implements OnInit, OnDestroy {
    protected override canDetach = false;
    constructor(
        private accountViewComponent: AccountViewComponent,
        private history: History,
    ) {
        super();
        this.accountViewComponent.forceContentCols = 6;
    }
    orders?: HistoryOrder[];
    override ngOnInit(): void {
        this.orders = this.history.orders;
        super.ngOnInit();
    }
    override ngOnDestroy(): void {
        this.accountViewComponent.forceContentCols = undefined;
        super.ngOnDestroy();
    }
}
